// Account-manager identity for the booking step. The backend owns routing,
// the display name, and the meeting URL; the frontend maps the returned AM key
// to its headshot asset in the view layer (see book-call/view/amHeadshots.ts).

export type AmKey = 'brooke' | 'klabera';

export const isAmKey = (value: string | null | undefined): value is AmKey =>
  value === 'brooke' || value === 'klabera';
